import { render, staticRenderFns } from "./PageFaceScanner.vue?vue&type=template&id=26a428a6"
import script from "./PageFaceScanner.vue?vue&type=script&lang=js"
export * from "./PageFaceScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports